import Client from "./Client";
import axios from "axios";
import AuthStorage from "./AuthStorage";

const {VUE_APP_API_HOST} = process.env;

export default class {

    /**
     * Login with facebook
     * @param {String} facebook_token
     * @returns {Promise<ServerUser>}
     */
    async loginWithFacebook(facebook_token) {
        let payload = {facebook_token};

        let user = await this.client.post(`${VUE_APP_API_HOST}/login/facebook`, payload);

        return this.storeAndReturnUserData(user);
    }

    /**
     * Get the current authenticate subscriber.
     *
     * @returns {Promise<AuthSubscriber>}
     */
    getAuthSubscriber() {
        return this.client.authGet(`${VUE_APP_API_HOST}/subscriber`);
    }

    /**
     * Get the score for a given profile, the
     * user can be authenticated or not.
     *
     * @param {EnergyProfile} profile
     * @returns {Promise<ProfileScore>}
     */
    async getScoreForProfile(profile) {
        let method = this.context.$auth.isLoggedIn() ? 'authPost' : 'post';

        return await this.client[method](`${VUE_APP_API_HOST}/profile`, profile);
    }

    /**
     * Send a message to app admins.
     *
     * @param {{name:String,phone:String,content:String}} message
     * @returns {Promise<*>}
     */
    async postMessage(message) {
        return await this.client.authPost(`${VUE_APP_API_HOST}/messages`, message);
    }

    /**
     * Get Report
     * @param {String} profileUUID
     * @returns {Promise<*>}
     */
    async getReport(profileUUID) {
        return await this.client.authGet(`${VUE_APP_API_HOST}/profile/${profileUUID}`);
    }

    /**
     * Refresh the token
     * @returns {Promise<ServerUser>}
     */
    async refreshToken() {
        try {
            /** @var {AxiosResponse} */
            let response = await axios.put(`${VUE_APP_API_HOST}/login/token`, {
                refresh_token: AuthStorage.getRefreshToken()
            });

            return this.storeAndReturnUserData(response.data.data);
        } catch (e) {
            AuthStorage.resetTokens();
            this.context.$alert(`Errore nell'autenticazione dell'utente.`);
            this.context.$routeTo('/');
            throw e;
        }
    }

    /**
     * Send the pin by email
     * @param {string} email
     * @param {boolean} newsletter
     * @returns {Promise<void>}
     */
    async sendPinByEmail(email, newsletter) {
        await this.client.post(`${VUE_APP_API_HOST}/login/email`, {
            email, newsletter
        });
    }

    /**
     *
     * @param {string} email
     * @param {string} pin
     * @returns {Promise<ServerUser>}
     */
    async verifyPin(email, pin) {
        let payload = {email, pin};

        let user = await this.client.post(`${VUE_APP_API_HOST}/login/pin`, payload);

        return this.storeAndReturnUserData(user)
    }

    /**
     * @param {ServerUser} user
     * @returns {ServerUser}
     */
    storeAndReturnUserData(user) {
        AuthStorage.setApiToken(user.api_token);
        AuthStorage.setRefreshToken(user.refresh_token);

        return user;
    }

    /**
     * @returns {Client}
     */
    get client() {
        return this._client = this._client
            ? this._client
            : new Client(this.context);
    }

    /**
     * @returns {Vue}
     */
    get context() {
        return this._context;
    }

    /**
     * @param {Vue} context
     */
    setContext(context) {
        this._context = context;
    }
}